
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/pagination/jst/PaginatedView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"paginatedView-loading\" role=\"alert\" aria-live=\"assertive\">\n    <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("paginated_view")
  },data:data},helper ? helper.call(depth0, "paginated_view.loading_more_results", "Loading more results", options) : helperMissing.call(depth0, "t", "paginated_view.loading_more_results", "Loading more results", options)))
    + "</span>\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '2c',
      bundle: 'jst/PaginatedView'
    });
  ;
    export default templates[name];
  